export default "__VITE_ASSET__ea71a03f__"